import { Component} from '@angular/core'
import { ApplicationArea } from 'src/app/shared/services/ppv.api'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Component({
   selector: 'app-mentoring-agreement',
   templateUrl: './mentoring-agreement.component.html',
   styleUrls: ['./mentoring-agreement.component.scss'],
   standalone: false,
})
export class MentoringAgreementComponent {
   powerAppUrl: SafeResourceUrl
	
   constructor(private authMgr: AuthManager, private sanitizer: DomSanitizer) {
	  this.authMgr.getCurrentUser().subscribe((user) => {
         console.log(user.roles)
  
         var userDVM = this.authMgr.canAccess(user, {
            application: ApplicationArea.DVM,
            roleName: ['DVM'],
         })
         var userMentoringAdmin = this.authMgr.canAccess(user, {
            application: ApplicationArea.Mentoring,
            roleName: ['MentoringAdmin'],
         })
		 var userMentoring = this.authMgr.canAccess(user, {
            application: ApplicationArea.Mentoring,
            roleName: ['Mentoring'],
         })

         if(userDVM || userMentoringAdmin || userMentoring) {
		    const rawUrl = 'https://apps.powerapps.com/play/e/default-523b8b04-c730-4da9-a587-46cf3a2eb728/a/4c462a74-014d-4ac0-a5cd-5315d2b5c79d?tenantId=523b8b04-c730-4da9-a587-46cf3a2eb728&hint=bbfa52eb-c227-4546-a9d1-91fe08775027&sourcetime=1748459705491'
            this.powerAppUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl)
		 }
      })
   }
}